module.exports = __webpack_public_path__ + "static/media/Video_Allow_Instruction_2.c080ec5c.jpg";